import React from 'react';
import logoBlack from '../../../assets/logo-noir.png';

import CONFIG from '../../../config';
import WidgetCheckbox from '../../../components/widgets/WidgetCheckbox';
import WidgetDatePicker from '../../../components/widgets/WidgetDatePicker';
import WidgetInputText from '../../../components/widgets/WidgetInputText';
import WidgetSelect from '../../../components/widgets/WidgetSelect';

import 'dayjs/locale/fr';
import axios from "axios";
import Base64 from 'crypto-js/enc-base64';
import Button from '@mui/material/Button';
import dayjs from 'dayjs';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import HomeIcon from '@mui/icons-material/Home';
import Link from '@mui/material/Link';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PersonIcon from '@mui/icons-material/Person';
import sha256 from 'crypto-js/sha256';
import WorkIcon from '@mui/icons-material/Work';
import { useNavigate, useParams } from 'react-router-dom';
import WidgetInputVille from '../../../components/widgets/WidgetInputVille';
import InfoIcon from '@mui/icons-material/Info';
import { IconButton } from '@mui/material';
import WidgetAlertbox from '../../../components/widgets/WidgetAlertbox';
import EuroIcon from '@mui/icons-material/Euro';


function InscriptionClient() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [alertTarif, openAlertTarif] = WidgetAlertbox(
    <>
      <div class="text-gray-900">
        <p class="mb-4">L'accompagnement comprend :</p>
        <ul class="list-disc ml-6 mb-6">
          <li>Aide à la constitution du dossier</li>
          <li>Recherches et propositions d'au moins 3 biens</li>
          <li>Visites</li>
          <li>Accompagnement pour la signature du bail et l'état des lieux</li>
          <li>Aide à l'installation (contrats d'énergie, d'internet et pour le déménagement)</li>
        </ul>
        <p class="mb-4">Tarifs de l'accompagnement :</p>
        <ul class="list-disc ml-6 mb-6">
          <li class="mb-2">Tarif particulier : 1000 € TTC</li>
          ou
          <li>Tarif entreprise : 1500 € HT</li>
        </ul>
      </div>
    </>, "informations et tarifs", false
  );
  const [eligibilityState, setEligibilityState] = React.useState(true);

  const [secteurOption, setSecteurOption] = React.useState({});
  React.useEffect(() => {
    axios.get(CONFIG.API_URL + '/api/get_secteurs', { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
      .then((response) => {
        switch (response.status) {
          case 200:
            let res = {};
            for (let i = 0; i < response.data.length; i++) {
              const secteurItem = response.data[i];
              res[secteurItem.toLowerCase()] = secteurItem;
            }
            res["autre"] = "Autre...";

            setSecteurOption(res);
            break;

          default:
            break;
        }
      })
      .catch((e) => {

      });
  }, []);

  const [mobiliOn, setMobiliOn] = React.useState(false);
  React.useEffect(() => {
    axios.get(CONFIG.API_URL + '/api/get_mobili_on', { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
      .then((response) => {
        switch (response.status) {
          case 200:
            setMobiliOn(response.data);
            break;

          default:
            break;
        }
      })
      .catch((e) => {

      });
  }, []);

  React.useEffect(() => {
    axios.get(CONFIG.API_URL + '/api/me', { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
      .then((response) => {
        switch (response.status) {
          case 200:
            navigate("/client/dossier");
            break;

          default:
            break;
        }
      })
      .catch((e) => {

      });
  }, []);

  const [preUser, setPreUser] = React.useState(null);
  React.useEffect(() => {
    axios.get(CONFIG.API_URL + '/api/get_client_fromcode/' + id, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
      .then((response) => {
        switch (response.status) {
          case 200:
            setPreUser(response.data);
            console.log(response.data)
            break;

          default:
            break;
        }
      })
      .catch((e) => {
        setPreUser({});
      });
  }, []);

  /* START: FORM ELIGIBILITY */
  const [adresse, setAdresse] = React.useState(null);
  const [codePostal, setCodePostal] = React.useState(null);
  const [ville, setVille] = React.useState(null);
  const [pays, setPays] = React.useState(null);

  const [tailleEntreprise, setTailleEntreprise] = React.useState(null);
  const [entreprisePrivee, setEntreprisePrivee] = React.useState(null);
  const [entrepriseAgri, setEntrepriseAgri] = React.useState(null);
  const [typeContrat, setTypeContrat] = React.useState(null);
  const [avecEssai, setAvecEssai] = React.useState(null);
  const [mute, setMute] = React.useState(null);
  const [dateEmbauche, setDateEmbauche] = React.useState(null);
  const [dateMutation, setDateMutation] = React.useState(null);
  const [dateFinContrat, setDateFinContrat] = React.useState(null);
  const [dateFinEssai, setDateFinEssai] = React.useState(null);

  const [secteurRecherche, setSecteurRecherche] = React.useState(null);
  const [secteurRecherchePrecision, setSecteurRecherchePrecision] = React.useState(null);

  const formEligibility = [
    [adresse, setAdresse],
    [codePostal, setCodePostal],
    [ville, setVille],
    [pays, setPays],

    [tailleEntreprise, setTailleEntreprise],
    [entreprisePrivee, setEntreprisePrivee],
    [entrepriseAgri, setEntrepriseAgri],
    [typeContrat, setTypeContrat],
    [avecEssai, setAvecEssai],
    [mute, setMute],
    [dateEmbauche, setDateEmbauche],
    [dateMutation, setDateMutation],
    [dateFinContrat, setDateFinContrat],
    [dateFinEssai, setDateFinEssai],

    [secteurRecherche, setSecteurRecherche],
    [secteurRecherchePrecision, setSecteurRecherchePrecision]
  ];
  /* END: FORM ELIGIBILITY */


  /* START: FORM CREATION */
  const [nom, setNom] = React.useState(null);
  const [prenom, setPrenom] = React.useState(null);
  const [email, setEmail] = React.useState(null);
  const [telephone, setTelephone] = React.useState(null);
  const [motDePasse, setMotDePasse] = React.useState(null);
  const [motDeDasseBis, setMotDeDasseBis] = React.useState(null);

  const [typeAcquisition, setTypeAcquisition] = React.useState(null);
  const [codePromo, setCodePromo] = React.useState(null);
  const [modeFacture, setModeFacture] = React.useState(null);
  // const [rgpdAccepte, setRgpdAccepte] = React.useState(null);

  const formCreation = [
    [nom, setNom],
    [prenom, setPrenom],
    [email, setEmail],
    [telephone, setTelephone],
    [motDePasse, setMotDePasse],
    [motDeDasseBis, setMotDeDasseBis],

    [typeAcquisition, setTypeAcquisition],
    [codePromo, setCodePromo],
    [modeFacture, setModeFacture],
    // [rgpdAccepte, setRgpdAccepte]
  ];
  /* END: FORM CREATION */


  const [currentPage, setCurrentPage] = React.useState(0);


  React.useEffect(() => {
    if (motDePasse !== null && motDeDasseBis !== null) {
      if (motDePasse.value !== motDeDasseBis.value) {
        if (!motDeDasseBis.error)
          setMotDeDasseBis((s) => ({ ...s, error: true, errorMessage: "Le mot de passe est différent" }));
      } else {
        if (motDeDasseBis.error)
          setMotDeDasseBis((s) => ({ ...s, error: false, errorMessage: null }));
      }
    }
  }, [motDePasse, motDeDasseBis]);

  React.useEffect(() => {
    setVille((s) => ({ ...s, value: '' }));
  }, [codePostal]);


  const submitFormEligibility = () => {
    var formEligibilityValid = true;

    if (adresse === null || adresse.value === '') {
      setAdresse((s) => ({ ...s, error: true }));
      formEligibilityValid = false;
    }

    if (codePostal === null || codePostal.value === '') {
      setCodePostal((s) => ({ ...s, error: true }));
      formEligibilityValid = false;
    }

    if (ville === null || ville.value === '') {
      setVille((s) => ({ ...s, error: true }));
      formEligibilityValid = false;
    }

    const paysRequired = codePostal !== null && codePostal.value === '99999';
    if (paysRequired && (pays === null || pays.value === '')) {
      setPays((s) => ({ ...s, error: true }));
      formEligibilityValid = false;
    }


    if (tailleEntreprise === null || tailleEntreprise.value === '') {
      setTailleEntreprise((s) => ({ ...s, error: true }));
      formEligibilityValid = false;
    }

    if (entreprisePrivee === null || entreprisePrivee.value === '') {
      setEntreprisePrivee((s) => ({ ...s, error: true }));
      formEligibilityValid = false;
    }

    if (entrepriseAgri === null || entrepriseAgri?.value === '') {
      setEntrepriseAgri((s) => ({ ...s, error: true }));
      formEligibilityValid = false;
    }

    if (typeContrat === null || typeContrat.value === '') {
      setTypeContrat((s) => ({ ...s, error: true }));
      formEligibilityValid = false;
    }

    if (avecEssai === null) {
      setAvecEssai((s) => ({ ...s, error: true }));
      formEligibilityValid = false;
    }

    if (mute === null) {
      setMute((s) => ({ ...s, error: true }));
      formEligibilityValid = false;
    }

    if (dateEmbauche === null || dateEmbauche.value === null) {
      setDateEmbauche((s) => ({ ...s, error: true }));
      formEligibilityValid = false;
    }

    const dateFinContratRequired = (typeContrat.value === 'cdd' || typeContrat.value === 'alternance');
    if (dateFinContratRequired && (dateFinContrat === null || dateFinContrat.value === null)) {
      setDateFinContrat((s) => ({ ...s, error: true }));
      formEligibilityValid = false;
    }

    const dateFinEssaiRequired = avecEssai.value  // && (typeContrat.value === 'cdd' || typeContrat.value === 'cdi');
    if (dateFinEssaiRequired && (dateFinEssai === null || dateFinEssai.value === null)) {
      setDateFinEssai((s) => ({ ...s, error: true }));
      formEligibilityValid = false;
    }

    const dateMutationRequired = mute.value;
    if (dateMutationRequired && (dateMutation === null || dateMutation.value === null)) {
      setDateMutation((s) => ({ ...s, error: true }));
      formEligibilityValid = false;
    }


    if (secteurRecherche === null || secteurRecherche.value === '') {
      setSecteurRecherche((s) => ({ ...s, error: true }));
      formEligibilityValid = false;
    }

    const secteurRecherchePrecisionRequired = secteurRecherche.value === 'autre';
    if (secteurRecherchePrecisionRequired && (secteurRecherchePrecision === null || secteurRecherchePrecision.value === '')) {
      setSecteurRecherchePrecision((s) => ({ ...s, error: true }));
      formEligibilityValid = false;
    }


    if (!formEligibilityValid) {
      return;
    }


    var payload = {};

    for (var i = 0; i < formEligibility.length; i++) {
      let [field, setField] = formEligibility[i];
      if (field !== null && field.value !== null && field.value !== '') {
        payload[field.id] = dayjs.isDayjs(field.value) ? field.value.toISOString() : field.value;
      }
    }

    axios.post(CONFIG.API_URL + '/api/client_eligibility', payload)
      .then((response) => {
        switch (response.status) {
          case 200:
            setEligibilityState(response.data);
            setCurrentPage((response.data && (mobiliOn || entrepriseAgri?.value)) ? 1 : 3);
            break;

          default:
            break;
        }
      })
      .catch((e) => {
        let response = e.response;

        if (response === undefined) {
          alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
          return;
        }

        switch (response.status) {
          default:
            alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
            break;
        }
      });
  };


  const submitFormCreation = () => {
    var formCreationValid = true;

    if (nom === null || nom.value === '') {
      setNom((s) => ({ ...s, error: true }));
      formCreationValid = false;
    }

    if (prenom === null || prenom.value === '') {
      setPrenom((s) => ({ ...s, error: true }));
      formCreationValid = false;
    }

    if (email === null || email.value === '') {
      setEmail((s) => ({ ...s, error: true }));
      formCreationValid = false;
    }

    if (telephone === null || telephone.value === '') {
      setTelephone((s) => ({ ...s, error: true }));
      formCreationValid = false;
    }

    if (motDePasse === null || motDePasse.value === '' || !(new RegExp("^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[\\W_])(.{9,})$")).test(motDePasse.value)) {
      setMotDePasse((s) => ({ ...s, error: true }));
      formCreationValid = false;
    }

    if (motDeDasseBis === null || motDeDasseBis.value === '') {
      setMotDeDasseBis((s) => ({ ...s, error: true }));
      formCreationValid = false;
    }

    if (motDePasse.value !== motDeDasseBis.value) {
      formCreationValid = false;
    }


    if (typeAcquisition === null || typeAcquisition.value === '') {
      setTypeAcquisition((s) => ({ ...s, error: true }));
      formCreationValid = false;
    }

    if (codePromo === null) {
      setCodePromo((s) => ({ ...s, error: true }));
      formCreationValid = false;
    }

    if (!(eligibilityState && (mobiliOn || entrepriseAgri?.value)) && (modeFacture === null || modeFacture.value === '')) {
      setModeFacture((s) => ({ ...s, error: true }));
      formCreationValid = false;
    }

    // if (rgpdAccepte === null || !rgpdAccepte.value) {
    //   setRgpdAccepte((s) => ({ ...s, error: true, errorMessage: "Vous devez accepter ..." }));  // TODO
    //   formCreationValid = false;
    // }


    if (!formCreationValid) {
      return;
    }


    var payload = { form_eligibility: {}, form_creation: {} };

    for (var i = 0; i < formEligibility.length; i++) {
      let [field, setField] = formEligibility[i];
      if (field !== null && field.value !== null && field.value !== '') {
        payload.form_eligibility[field.id] = dayjs.isDayjs(field.value) ? field.value.toISOString() : field.value;
      }
    }

    for (var i = 0; i < formCreation.length; i++) {
      let [field, setField] = formCreation[i];
      if (field !== null && field.value !== null && field.value !== '') {
        payload.form_creation[field.id] = dayjs.isDayjs(field.value) ? field.value.toISOString() : field.value;
      }
    }

    payload.form_creation['mot_de_passe'] = Base64.stringify(sha256(motDePasse.value));

    if (id !== undefined) {
      payload.form_creation['code_creation'] = id;
    }

    axios.post(CONFIG.API_URL + '/api/client_creation', payload)
      .then((response) => {
        switch (response.status) {
          case 200:
            setCurrentPage(2);
            break;

          default:
            break;
        }
      })
      .catch((e) => {
        let response = e.response;

        if (response === undefined) {
          alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
          return;
        }

        switch (response.status) {
          case 412:
            if (!response.data.detail.eligibility) {
              setCurrentPage(3);
            } else {
              for (var i = 0; i < formCreation.length; i++) {
                let [field, setField] = formCreation[i];
                if (field !== null && field.id in response.data.detail.creation) {
                  setField((s) => ({ ...s, error: true, errorMessage: response.data.detail.creation[field.id] }));
                }
              }
            }
            break;

          default:
            alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
            break;
        }
      });
  };


  return (
    <>
      {alertTarif}
      {preUser !== null &&
        <>
          <div className='max-w-4xl mx-auto shrink-0' style={{ display: (currentPage === 0) ? 'grid' : 'none' }}>
            <div className='grid grid-cols-12 gap-x-4 m-6'>
              <div className='col-span-12 w-full text-center mb-4'>
                <h1>Vérifions votre <b>éligibilité</b></h1>
                Les champs obligatoires apparaîtront en surbrillance si manquants.
              </div>

              <div className='col-span-12 w-full text-left text-sm bg-red-200 rounded-md p-2'>
                Nous sommes désolés pour la gêne occasionnée mais nous avons un problème technique vis-à-vis du <b>profil étudiant hors alternance</b>. 
                <br></br>
                <br></br>
                Nous vous invitons à entrer un profil alternant avec des dates fictives (01/01/2001 afin que l'on puisse détecter) et des informations fictives pour ce qui est lié à l'emploi. 
                <br></br>
                <br></br>
                Pour le dépôt des pièces, à la place du contrat, merci de mettre une nouvelle fois le justificatif étudiant.
              </div>
            </div>

            <div className='grid grid-cols-12 gap-x-4 m-6 mt-0 p-6 pb-2 bg-white my-shadow'>
              <div className='flex col-span-12 w-full mb-1 text-center items-end'>
                <div className='pr-2 text-ame-gray'>
                  <HomeIcon fontSize='large'></HomeIcon>
                </div>
                <div>
                  <h2>Logement de départ</h2>
                </div>
              </div>

              <div className='col-span-12 w-full mb-4'>
                <hr></hr>
              </div>

              <div className='col-span-12 w-full mb-4'>
                <WidgetInputText state={adresse} setState={setAdresse} id={'adresse'} text={"Adresse"} value={preUser?.dossier?.adresse_depart?.adresse} />
              </div>

              <div className='col-span-6 w-full mb-4'>
                <WidgetInputText state={codePostal} setState={setCodePostal} id={'code_postal'} text={"Code postal"} value={preUser?.dossier?.adresse_depart?.code_postal} />
              </div>

              <div className='col-span-6 w-full mb-4'>
                <WidgetInputVille state={ville} setState={setVille} code_postal={codePostal?.value} id={'ville'} text={"Ville"} value={preUser?.dossier?.adresse_depart?.ville} />
              </div>

              {codePostal !== null && codePostal.value === '99999' &&
                <div className='col-span-6 w-full mb-4'>
                  <WidgetInputText state={pays} setState={setPays} id={'pays'} text={"Pays"} value={preUser?.dossier?.adresse_depart?.pays} />
                </div>
              }
            </div>

            <div className='grid grid-cols-12 gap-x-4 m-6 mt-0 p-6 pb-2 bg-white my-shadow'>
              <div className='flex col-span-12 w-full mb-1 text-center items-end'>
                <div className='pr-2 text-ame-gray'>
                  <WorkIcon fontSize='large'></WorkIcon>
                </div>
                <div>
                  <h2>Emploi</h2>
                </div>
              </div>

              <div className='col-span-12 w-full mb-4'>
                <hr></hr>
              </div>

              <div className='col-span-6 w-full mb-4'>
                <WidgetSelect state={tailleEntreprise} setState={setTailleEntreprise} id={'taille_entreprise'} text={"Taille d'entreprise"} value={preUser?.dossier?.taille_entreprise}
                  options={{
                    '1-9': "1 à 9 employés (siège compris)",
                    '10-49': "10 à 49 employés (siège compris)",
                    '50-199': "50 à 199 salariés (siège compris)",
                    '200-999': "200 à 999 salariés (siège compris)",
                    '1000+': "+1000 salariés (siège compris)"
                  }}
                />
              </div>

              <div className='col-span-6 w-full mb-4 content-center grid'>
                <WidgetSelect state={entreprisePrivee} setState={setEntreprisePrivee} id={'entreprise_privee'} text={"Type d'entreprise"} value={preUser?.dossier?.entreprise_privee}
                  options={{
                    'true': "Entreprise privée",
                    'false': "Entreprise publique"
                  }}
                />
              </div>

              <div className='col-span-12 w-full mb-4 content-center grid'>
                <WidgetCheckbox state={entrepriseAgri} setState={setEntrepriseAgri} id={'entreprise_agri'} text={"Entreprise du secteur agricole* (Crédit Agricole, Invivo, Top Semence, etc.)"} value={preUser?.dossier?.entreprise_agri} tips='*Merci de vérifier avec votre entreprise si vous dépendez de ce secteur afin de bénéficier de la gratuité du service' />
              </div>

              <div className='col-span-6 w-full mb-4'>
                <WidgetSelect state={typeContrat} setState={setTypeContrat} id={'type_contrat'} text={"Type de contrat"} value={preUser?.dossier?.type_contrat}
                  options={{
                    'cdi': "CDI",
                    'cdd': "CDD",
                    'alternance': "Alternance"
                  }}
                />
              </div>

              <div className='col-span-6 w-full mb-4 grid'>
                <WidgetDatePicker state={dateEmbauche} setState={setDateEmbauche} id={'date_embauche'} text={"Date d'embauche"} value={preUser?.dossier?.date_embauche} />
              </div>

              <div className='col-span-6 w-full mb-4 content-center grid pl-2'>
                <WidgetCheckbox state={mute} setState={setMute} id={'mute'} text={"Mutation"} value={(preUser?.dossier?.mute === undefined) ? false : preUser?.dossier?.mute} />
              </div>

              <div className='col-span-6 w-full mb-4 content-center grid pl-2'>
                <WidgetCheckbox state={avecEssai} setState={setAvecEssai} id={'avec_essai'} text={"Avec période d'essai"} value={(preUser?.dossier?.avec_essai === undefined) ? false : preUser?.dossier?.avec_essai} />
              </div>

              {mute !== null && mute.value &&
                <div className='col-span-6 w-full mb-4 grid'>
                  <WidgetDatePicker state={dateMutation} setState={setDateMutation} id={'date_mutation'} text={"Date de mutation"} value={preUser?.dossier?.date_mutation} />
                </div>
              }

              {avecEssai !== null && typeContrat !== null && (avecEssai.value  /* && (typeContrat.value === 'cdd' || typeContrat.value === 'cdi')*/) &&
                <div className='col-span-6 w-full mb-4 grid'>
                  <WidgetDatePicker state={dateFinEssai} setState={setDateFinEssai} id={'date_fin_essai'} text={"Date de fin de période d'essai"} value={preUser?.dossier?.date_fin_essai} />
                </div>
              }

              {typeContrat !== null && (typeContrat.value === 'cdd' || typeContrat.value === 'alternance') &&
                <div className='col-span-6 w-full mb-4 grid'>
                  <WidgetDatePicker state={dateFinContrat} setState={setDateFinContrat} id={'date_fin_contrat'} text={"Date de fin de contrat"} value={preUser?.dossier?.date_fin_contrat} />
                </div>
              }
            </div>

            <div className='grid grid-cols-12 gap-x-4 m-6 mt-0 p-6 pb-2 bg-white my-shadow'>
              <div className='flex col-span-12 w-full mb-1 text-center items-end'>
                <div className='pr-2 text-ame-gray'>
                  <LocationOnIcon fontSize='large'></LocationOnIcon>
                </div>
                <div>
                  <h2>Destination</h2>
                </div>
              </div>

              <div className='col-span-12 w-full mb-4'>
                <hr></hr>
              </div>

              <div className='col-span-6 w-full mb-4'>
                <WidgetSelect state={secteurRecherche} setState={setSecteurRecherche} id={'secteur_recherche'} text={"Secteur de recherche"} value={preUser?.dossier?.secteur_recherche}
                  options={secteurOption}
                />
              </div>

              {secteurRecherche !== null && secteurRecherche.value === 'autre' &&
                <div className='col-span-6 w-full mb-4'>
                  <WidgetInputText state={secteurRecherchePrecision} setState={setSecteurRecherchePrecision} id={'secteur_recherche_precision'} text={"Précisez autre"} value={preUser?.dossier?.secteur_recherche_precision} />
                </div>
              }
            </div>

            <div className='grid grid-cols-12 gap-x-4 m-6 mt-0'>
              <div className='col-span-12 w-full text-right'>
                <Button variant='contained' onClick={submitFormEligibility}>
                  Vérifier mon éligibilité
                </Button>
              </div>
              <div className='col-span-12 w-full mt-6 text-xs text-justify'>
                En tant que responsable de traitement, Mouv'Immo collecte vos données à caractère personnel aux fins notamment
                d'étudier votre éligibilité à l'offre proposée. Vos données sont destinées aux différents services administratifs et
                commercial de Mouv'Immo. Vos données seront conservées uniquement si vous êtes éligible et conformément à
                notre politique de conservation des données. Les données mentionnées par un astérisque (*) sont obligatoires.
                Conformément à la Loi Informatique et Liberté Loi n° 78-17 du 6 janvier 1978 modifiée et au Règlement Général sur la
                Protection des Données Règlement (UE) 2016/679 du Parlement européen et du Conseil du 27 avril 2016 dit RGPD, vous
                disposez d'un droit d'accès, de rectification, d'effacement, de limitation et d'opposition au traitement de vos données.
                Vous pouvez exercer vos droits en envoyant un mail à agence@mouv-immo.com ou par courrier à Mouv'Immo,
                16 rue Lieutenant-Colonel Prévost, 69006 Lyon. Pour plus d'informations concernant le traitement de vos données à
                caractère personnel, vous pouvez consulter notre politique en ligne.
              </div>
            </div>
          </div>



          <div className='max-w-4xl mx-auto shrink-0' style={{ display: (currentPage === 1) ? 'grid' : 'none' }}>
            <div className='grid grid-cols-12 gap-x-4 m-6'>
              {(eligibilityState && (mobiliOn || entrepriseAgri?.value)) &&
                <>
                  <div className='col-span-12 w-full text-center '>
                    <h1>Félicitations, <b>vous êtes éligible à l'aide {(entrepriseAgri?.value) ? "Agri-Mobilité" : "Mobili-Pass"} !</b></h1>
                  </div>
                  <div className='col-start-2 col-span-10 w-full text-center mb-6'>
                    Cette aide vous permet de bénéficier de notre accompagnement dans la recherche de votre logement gratuitement.
                  </div>
                </>
              }
              {!(eligibilityState && (mobiliOn || entrepriseAgri?.value)) &&
                <div className='col-start-2 col-span-10 w-full text-center mb-6'>
                  <h1>Félicitations, <b>vous avez choisi de bénéficier de notre accompagnement !</b></h1>
                </div>
              }

              <div className='col-span-12 w-full text-center'>
                <h2>Créons votre <b>espace client</b></h2>
                Les champs obligatoires apparaîtront en surbrillance si manquants.
              </div>
            </div>

            <div className='grid grid-cols-12 gap-x-4 m-6 mt-0 p-6 pb-2 bg-white my-shadow'>
              <div className='flex col-span-12 w-full mb-1 text-center items-end'>
                <div className='pr-2 text-ame-gray'>
                  <PersonIcon fontSize='large'></PersonIcon>
                </div>
                <div>
                  <h2>Informations personnelles</h2>
                </div>
              </div>

              <div className='col-span-12 w-full mb-4'>
                <hr></hr>
              </div>

              <div className='col-span-6 w-full mb-4'>
                <WidgetInputText state={nom} setState={setNom} id={'nom'} text={"Nom"} value={preUser?.nom} />
              </div>

              <div className='col-span-6 w-full mb-4'>
                <WidgetInputText state={prenom} setState={setPrenom} id={'prenom'} text={"Prénom"} value={preUser?.prenom} />
              </div>

              <div className='col-span-6 w-full mb-4'>
                <WidgetInputText state={email} setState={setEmail} id={'email'} text={"Email"} regex={"^.+@.+$"} regex_helper={"Adresse email non valide"} value={preUser?.email} />
              </div>

              <div className='col-span-6 w-full mb-4'>
                <WidgetInputText state={telephone} setState={setTelephone} id={'telephone'} text={"Téléphone"} regex_key={"[+0-9 ]"} value={preUser?.telephone} />
              </div>

              <div className='col-span-6 w-full mb-4'>
                <WidgetInputText state={motDePasse} setState={setMotDePasse} id={'mot_de_passe'} text={"Mot de passe"} type={'password'} regex={"^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[\\W_])(.{9,})$"} tips={"Votre mot de passe doit comporter au moins : une minuscule, une majuscule, un chiffre, un symbole, et 9 caractères"} />
              </div>

              <div className='col-span-6 w-full mb-4'>
                <WidgetInputText state={motDeDasseBis} setState={setMotDeDasseBis} id={'mot_de_passe_bis'} text={"Confirmez le mot de passe"} type={'password'} />
              </div>
            </div>

            <div className='grid grid-cols-12 gap-x-4 m-6 mt-0 p-6 pb-2 bg-white my-shadow'>
              <div className='flex col-span-12 w-full mb-1 text-center items-end'>
                <div className='pr-2 text-ame-gray'>
                  <FactCheckIcon fontSize='large'></FactCheckIcon>
                </div>
                <div>
                  <h2>Compléments d'informations</h2>
                </div>
              </div>

              <div className='col-span-12 w-full mb-4'>
                <hr></hr>
              </div>

              <div className='col-span-6 w-full mb-4'>
                <WidgetSelect state={typeAcquisition} setState={setTypeAcquisition} id={'type_acquisition'} text={"Comment vous nous avez connus ?"} value={preUser?.dossier?.type_acquisition}
                  options={{
                    'recommendation': "Recommandation",
                    'bouche_oreille': "Bouche à oreille",
                    'partenariat_ecole': "Partenariat école",
                    'partenariat_entreprise': "Partenariat entreprise",
                    'telephone': "Prospection téléphonique",
                    'flyers': "Flyers",
                    'salon': "Salon",
                    'vitrine': "Vitrine",
                    'google': "Google",
                    'facebook': "Facebook",
                    'linkedin': "LinkedIn",
                    'instagram': "Instagram",
                    'autre': "Autre..."
                  }}
                />
              </div>

              <div className='col-span-6 w-full mb-4'>
                <WidgetInputText state={codePromo} setState={setCodePromo} id={'code_promo'} text={"Code de parrainage"} value={preUser?.dossier?.code_promo} />
              </div>

              {/* <div className='col-span-12 w-full mb-4 content-center grid pl-2'>
                <WidgetCheckbox state={rgpdAccepte} setState={setRgpdAccepte} id={'rgpd_accepte'} text={"<Phrase RGPD>"} />
              </div> */}
            </div>

            <div className={'grid grid-cols-12 gap-x-4 m-6 mt-0 p-6 pb-2 bg-white my-shadow ' + ((!(eligibilityState && (mobiliOn || entrepriseAgri?.value))) ? "" : "hidden")}>
              <div className='flex col-span-12 w-full mb-1 text-center items-end'>
                <div className='pr-2 text-ame-gray'>
                  <EuroIcon fontSize='large'></EuroIcon>
                </div>
                <div>
                  <h2>Mode de facturation</h2>
                </div>
              </div>

              <div className='col-span-12 w-full mb-4'>
                <hr></hr>
              </div>

              <div className='col-span-6 w-full mb-4'>
                <WidgetSelect state={modeFacture} setState={setModeFacture} id={'type_facturation'} text={"Mode de facturation"} value={preUser?.dossier?.type_facturation}
                  options={{
                    'Facturation directe particulier': 'Facturation directe particulier',
                    'Facturation directe entreprise': 'Facturation directe entreprise'
                  }}
                />
              </div>
              <div className='col-span-1 w-full text-left'>
                <IconButton aria-label="delete" onClick={() => openAlertTarif(x => !x)}>
                  <InfoIcon />
                </IconButton>
              </div>
            </div>

            <div className='grid grid-cols-12 gap-x-4 m-6 mt-0'>
              <div className='col-span-6 w-full text-left'>
                <Button variant='outlined' onClick={() => setCurrentPage(0)}>
                  Précédent
                </Button>
              </div>
              <div className='col-span-6 w-full text-right'>
                <Button variant='contained' onClick={submitFormCreation}>
                  Créer mon espace
                </Button>
              </div>
              <div className='col-span-12 w-full mt-6 text-xs text-justify'>
                En tant que responsable de traitement, Mouv'Immo collecte vos données à caractère personnel aux fins notamment
                de la création et de la gestion de votre compte utilisateur, de l'instruction et le suivi de votre demande, de la réalisation
                d'enquêtes de satisfaction, d'études marketing et statistiques. Vos données sont destinées aux différents services
                administratifs, commercial, marketing de Mouv'Immo, aux organismes en charge de votre prise en charge et aux
                partenaires en charge de la recherche de biens. Vos données seront conservées le temps nécessaire à l'exécution des
                différentes démarches et selon notre politique de conservation des données. Les données mentionnées par un
                astérisque (*) sont obligatoires. Conformément à la Loi Informatique et Liberté Loi n° 78-17 du 6 janvier 1978 modifiée
                et au Règlement Général sur la Protection des Données Règlement (UE) 2016/679 du Parlement européen et du Conseil
                du 27 avril 2016 dit RGPD, vous disposez d'un droit d'accès, de rectification, d'effacement, de limitation et d'opposition
                au traitement de vos données. Vous pouvez exercer vos droits en envoyant un mail à agence@mouv-immo.com ou
                par courrier à Mouv'Immo, 16 rue Lieutenant-Colonel Prévost, 69006 Lyon. Pour plus d'informations concernant le
                traitement de vos données à caractère personnel, vous pouvez consulter notre politique en ligne.
              </div>
            </div>
          </div>



          <div className='m-6 grid-cols-12 gap-x-4 shrink-0 p-6 max-w-lg mx-auto bg-white my-shadow' style={{ display: (currentPage === 2) ? 'grid' : 'none' }}>
            <div className='col-start-3 col-span-8 w-full item-center mb-6'>
              <img src={logoBlack} alt="Logo" />
            </div>

            <div className='col-span-12 w-full mb-4 text-center'>
              <h1>Félicitations, <b>votre espace est créé</b></h1>
            </div>

            <div className='col-start-2 col-span-10 w-full text-center bg-green-200 rounded-md p-2'>
              Vous devez maintenant <b>vérifier votre email</b> pour activer votre compte avant de <Link variant='contained' href={CONFIG.BASE_URL + "/connexion"}><span className='text-black underline decoration-black hover:decoration-2'>vous connecter</span></Link>. <br></br><br></br>Pensez à vérifier vos spams.
            </div>
          </div>



          <div className='m-6 grid-cols-12 gap-x-4 shrink-0 p-6 max-w-lg mx-auto bg-white my-shadow' style={{ display: (currentPage === 3) ? 'grid' : 'none' }}>
            <div className='col-start-3 col-span-8 w-full item-center mb-6'>
              <img src={logoBlack} alt="Logo" />
            </div>

            <div className='col-span-12 w-full mb-6 text-center'>
              {!eligibilityState &&
                <b>Félicitations ! Vous pouvez bénéficier de notre aide de recherche de logement avec une facturation directe ou via votre entreprise !</b>
              }
              {eligibilityState && !mobiliOn &&
                <b>Félicitations ! Vous pouvez bénéficier de notre aide de recherche de logement avec une facturation directe ou via votre entreprise !</b>
              }
              <br></br>
              <br></br>
              L'accompagnement comprend :
              <ul className="list-disc list-inside">
                <li>Aide à la constitution du dossier</li>
                <li>Recherches et propositions d'au moins 3 biens</li>
                <li>Visites</li>
                <li>Accompagnement pour la signature du bail et l'état des lieux</li>
                <li>Aide à l'installation (contrats d'énergie, d'internet et pour le déménagement)</li>
              </ul>
              <br></br>
              <br></br>
              Tarifs de l'accompagnement :
              <ul className="list-disc list-inside">
                <li>Tarif particulier : 1000 € TTC</li>
                ou
                <li>Tarif entreprise : 1500 € HT</li>
              </ul>
            </div>

            <div className='col-start-2 col-span-5 w-full text-right h-full'>
              <Button className='w-full h-full' variant='outlined' onClick={() => window.location.replace("https://mouv-immo.com/")}>
                Annuler la demande
              </Button>
            </div>
            <div className='col-span-5 w-full text-right'>
              <Button className='w-full' type="submit" variant='contained' onClick={() => setCurrentPage(1)}>
                Bénéficier d'un accompagnement payant
              </Button>
            </div>
            <div className='col-span-1 w-full text-left'>
              <IconButton aria-label="delete" onClick={() => openAlertTarif(x => !x)}>
                <InfoIcon />
              </IconButton>
            </div>

            {/* <div className='col-start-2 col-span-10 w-full text-center bg-red-200 rounded-md p-2'>
              <a variant='contained' href="https://mouv-immo.com/"><span className='text-black underline decoration-black hover:decoration-2'>Cliquez ici</span></a> pour revenir à l'accueil.
            </div> */}
          </div>
        </>
      }
    </>
  );
}

export default InscriptionClient;